import { z } from 'zod';
import '@apexdesigner/schema-tools';
import {
  belongsTo,
  hasMany,
  options,
  references,
} from '@apexdesigner/schema-tools';

export const token = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    referenceNumber: z
      .number()
      .nullable()
      .optional()
      .describe('Human-readable reference number'),

    activityId: z
      .string()
      .nullable()
      .optional()
      .describe('Current activity where this token is located'),

    status: options([
      { value: 'Active', name: 'Active' },
      { value: 'Paused', name: 'Paused' },
      { value: 'Error', name: 'Error' },
      { value: 'Complete', name: 'Complete' },
    ])
      .nullable()
      .optional()
      .describe('Current state of this token'),

    errorMessage: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Error details if the token encountered a problem'),

    errorCode: z
      .string()
      .nullable()
      .optional()
      .describe('Stable error code if the token failed with a known error'),

    loopItems: z
      .unknown()
      .nullable()
      .optional()
      .hidden()
      .presentAs('json')
      .describe(
        "The items a looping activity's loop array evaluated to when this token arrived, kept for the life of the loop so later iterations and `results` line up with them",
      ),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    processInstanceId: z
      .uuid()
      .hidden()
      .describe('Foreign key to ProcessInstance'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    processInstance: belongsTo('ProcessInstance'),

    userTasks: hasMany('UserTask'),

    serviceTasks: hasMany('ServiceTask'),

    childProcessInstances: hasMany('ProcessInstance', 'parentTokenId'),

    tokenHistories: hasMany('TokenHistory'),

    downstreamLinks: hasMany('TokenLink', 'upstreamTokenId'),

    upstreamLinks: hasMany('TokenLink', 'downstreamTokenId'),

    timers: hasMany('Timer'),

    messageListeners: hasMany('MessageListener'),

    myUserTasks: hasMany('MyUserTask'),

    conditionWatchers: hasMany('ConditionWatcher'),

    tenant: references('Tenant'),
  })
  .describe('Tracks the current position in a process flow')
  .as('Token');

export { token as tokenSchema };
